export default __webpack_public_path__ + "static/mount_chiliad_weed_farm-8e994188615e923d89a18723c688c6ea.png";